<template>
    <TableActionsContainer :panelStyle="panelStyle" :isShow="isShow">
        <template #buttons>
            <Button @click="deleteSelected" :label="$t('lang.main.table.components.checkbox_keys_action.delete_selected')" size="small" />
            <Button @click.prevent="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
        <template #footer>
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ $t('lang.main.table.components.checkbox_keys_action.organic') }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ $t('lang.main.table.components.checkbox_keys_action.context') }}</label>
                </div>
            </div>
        </template>
    </TableActionsContainer>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import {nextTick} from "vue";
import TableActionsContainer from "./container.vue";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import GroupReportApi from "../../../api/GroupReportApi";

export default {
    data() {
        return {
            rollUp: false,
            selectedTo: null,
            model: {
                organic: true,
                context: false,
            }
        }
    },
    props: {
        reportRid: {
            type: String,
            required: true,
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.$emitter.on(Listeners.TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
    },
    methods: {
        async deleteSelected() {
            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);
            await GroupReportApi.removeKeywords(
                this.reportRid,
                Object.assign({}, this.model, { keys: this.selectedTo })
            );
            this.clearSelectedTo();
            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE);
            this.$emitter.emit(Listeners.LOAD_GROUP_REPORT_DATA_FROM_HASH);
        },
        clearSelectedTo() {
            this.$emitter.emit(Listeners.TABLE_CLEAR_SELECTED);
        },
        handleScroll(){
            if (!this.$parent.$el || !this.$parent.$el.getElementsByClassName('p-datatable')) {
                return
            }

            const table = this.$parent.$el.getElementsByClassName('p-datatable')[0];
            this.style = {
                top: (
                    (window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)
                        ? (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px'
                        : (window.innerHeight - 200) + 'px'
                ),
            };
        }
    },
    computed: {
        panelStyle() {
            return Object.assign(
                {},
                this.style,
                this.rollUp ? {padding: '15px', opacity: 0.5} : {}
            );
        },
        isShow() {
            return !!this.selectedTo;
        }
    },
    watch: {
        selectedTo() {
            let self = this;
            nextTick(() => {
                self.handleScroll();
            });
        }
    },
    components: {
        TableActionsContainer,
        Button,
        Checkbox,
    }
}
</script>
